import React, { useState } from 'react';

function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(null); // 'success' | 'error' | null
  const [mensaje, setMensaje] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus(null);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL || ''}/api/newsletter/suscribir`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      if (data.success) {
        setStatus('success');
        setMensaje(data.message);
        setEmail('');
      } else {
        setStatus('error');
        setMensaje(data.message || 'Error al suscribirse.');
      }
    } catch {
      setStatus('error');
      setMensaje('No se pudo conectar con el servidor.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="bg-[#1E3A5F] text-white py-12">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-2xl font-bold font-montserrat mb-4">
          Suscríbete para recibir información, últimas noticias y otras ofertas interesantes
        </h2>
        <form className="flex justify-center" onSubmit={handleSubmit}>
          <input
            type="email"
            id="newsletter-email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Tu correo electrónico"
            required
            className="rounded-l-full px-6 py-3 border-none focus:outline-none text-gray-800 w-72"
          />
          <button
            type="submit"
            disabled={loading}
            className="bg-[#2AA8B0] rounded-r-full px-6 py-3 text-white font-semibold hover:bg-[#1E3A5F] transition-colors duration-300 disabled:opacity-60"
          >
            {loading ? 'Enviando...' : 'Enviar'}
          </button>
        </form>
        {status && (
          <p className={`mt-3 text-sm font-medium ${status === 'success' ? 'text-green-300' : 'text-red-300'}`}>
            {mensaje}
          </p>
        )}
      </div>
    </section>
  );
}

export default NewsletterSection;
